module.exports = __webpack_public_path__ + "static/img/6545_phase_function_Paper_PointsHejduk_Prediction.6f8e050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6545_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lu5E
// module chunks = 0